import React, { Component } from 'react';
import PageTitle from '../components/PageTitle';
import Member from '../components/Member';
import membersList from '../data/players.json';
import OnPageLoaded from '../utils/onpageloaded';
//import WOW from 'wowjs';

class Members extends Component {
    componentDidMount() {
        document.title = "Gruppo balfolk Damatrà - Componenti del gruppo";
        const description="La formazione completa del nostro gruppo folk, che vi farà ballare con tante danze popolari da tutta Europa.";
        document.querySelector('meta[name="description"]').setAttribute("content", description);
        OnPageLoaded(true, true);
    }

    render() {
        return (
            <div>
                <PageTitle title="Componenti" bgimgurl="/img/titlebg/membri.jpg"></PageTitle>
                <div className="container">
                    <div className="row mb-lg-4 center-on-small-only">
                        {membersList.map((member,index)=> <Member key={index} {...member}></Member>)}
                    </div>
                </div>
            </div>
        );
    }
}

export default Members;


// WEBPACK FOOTER //
// ./src/pages/Members.js